import clsx from "clsx";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

declare global {
  interface Window {
    nhn: {
      husky: {
        EZCreator: {
          createInIFrame: (params: any) => void;
        };
      };
    };
    oEditors: any;
  }
}

const SmartEditor = forwardRef<
  any,
  { id?: string; defaultValue?: string; autofocus?: boolean }
>(
  (
    {
      id = "editorArea",
      defaultValue = `<p>안녕하세요, 김승리 국어연구실 (본인 이름) 조교 입니다. </p><p><br></p><p>

(답변을 작성해주세요. 해당 영역은 답변 작성 시 삭제 바랍니다.)&nbsp;</p><p><br></p><p>
감사합니다. 더 궁금하신 내용이 있다면 언제든 질문해주시기 바랍니다 :)&nbsp;</p><p><br></p><p>
(응원 멘트를 작성해주세요. 해당 영역은 답변 작성 시 삭제 바랍니다.)</p>`,
      autofocus,
    },
    ref,
  ) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const editorRef = useRef<any>([]);
    const [contentPending, setContentPending] = useState<string | null>(null);

    useImperativeHandle(ref, () => ({
      getContent: () => editorRef.current?.getById?.[id].getContents?.(),
      focus: () => editorRef.current?.getById[id].exec("FOCUS"),
      setContent: (content: string) => {
        setContentPending(content);
      },
    }));

    useEffect(() => {
      if (isLoaded && contentPending !== null) {
        editorRef.current?.getById[id].setContents(contentPending);
        setContentPending(null);
      }
    }, [contentPending, isLoaded]);

    useEffect(() => {
      const initializeEditor = () => {
        if (window.nhn?.husky?.EZCreator) {
          window.nhn.husky.EZCreator.createInIFrame({
            oAppRef: editorRef.current,
            elPlaceHolder: id,
            sSkinURI: "/smarteditor/SmartEditor2Skin.html",
            htParams: {
              bUseToolbar: true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)
              bUseVerticalResizer: true, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)
              bUseModeChanger: true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)
              //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)
              //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록
              I18N_LOCALE: "ko_KR",
            },
            fOnAppLoad: function () {
              editorRef.current?.getById[id].setContents(defaultValue);

              if (autofocus) {
                editorRef.current?.getById[id].exec("FOCUS");
              }
              setIsLoaded(true);
            },
            fCreator: "createSEditor2",
          });
        } else {
          console.error("SmartEditor2 library not loaded.");
        }
      };

      const intervalId = setInterval(() => {
        if (window.nhn?.husky?.EZCreator) {
          initializeEditor();
          clearInterval(intervalId);
        }
      }, 100);

      return () => {
        clearInterval(intervalId);
      };
    }, []);

    return (
      <div
        className={clsx(
          "w-full bg-white",
          isLoaded ? "min-h-[254px]" : "h-[254px]",
        )}
      >
        <textarea className="w-[99%]" id={id} defaultValue="" />
      </div>
    );
  },
);

SmartEditor.displayName = "SmartEditor";

export default SmartEditor;
